import React from "react";
import { DataTable, Icon, Overlay } from "../widgets";
import { LOAD_TYPE } from "../../constants";
import FarmAccessPopover from "./FarmAccessPopover";

const FarmRow = ({
  organizationList,
  organizationId,
  farm,
  handleFarmEdit,
  handleArchived,
  selectedViewType,
  handleUnArchived,
  showNotificationConfig,
  handleNotificationConfig,
}) => {
  const { organization_name, theme_config, theme_name } =
    organizationList.find((o) => o.organization_uuid === organizationId) || {};
  const getThemeColor = (themeConfig) =>
    ((themeConfig || {}).primary || {}).main || null;

  return (
    <>
      <DataTable.Row>
        <DataTable.Cell className="highlight-row" colSpan={7}>
          <div className="farm-media">
            <Overlay title={theme_name} placement="top">
              <span
                className="farm-media__box"
                style={{ backgroundColor: getThemeColor(theme_config) }}
              />
            </Overlay>
            <span className="farm-media__text">{organization_name}</span>
          </div>
        </DataTable.Cell>
      </DataTable.Row>
      {farm.map((e, index) => {
        return (
          <DataTable.Row key={index}>
            <DataTable.Cell style={{ width: "40px" }}>
              {e.rowIndex}
            </DataTable.Cell>
            <DataTable.Cell>{e.name}</DataTable.Cell>
            <DataTable.Cell>{e.timezone}</DataTable.Cell>
            <DataTable.Cell>
              {e.load_type === LOAD_TYPE.MANUAL ? "Manual" : "Auto"}
            </DataTable.Cell>
            <DataTable.Cell className="text-center">
              <FarmAccessPopover
                farmAccessCode={e.farm_access_code}
                farmUuid={e.farm_uuid}
              />
            </DataTable.Cell>
            <DataTable.Cell style={{ width: "80px", textAlign: "center" }}>
              {selectedViewType === 1 && (
                <Icon
                  title={"Edit"}
                  onClick={() =>
                    handleFarmEdit(
                      e.farm_uuid,
                      e.name,
                      e.load_type,
                      e.load_mode,
                      e.timezone_id
                    )
                  }
                  className="fa fa-pencil cursor-pointer pr-3"
                  ariaHidden="true"
                />
              )}
              {selectedViewType === 1 && (
                <Icon
                  title={"Archived"}
                  onClick={() => handleArchived(e.farm_uuid)}
                  className="fa fa-arrow-circle-down cursor-pointer fa-lg pl-3"
                  ariaHidden="true"
                />
              )}
              {selectedViewType === 2 && (
                <Icon
                  title={"Un-Archived"}
                  onClick={() => handleUnArchived(e.farm_uuid)}
                  className="fa fa-arrow-circle-up cursor-pointer fa-lg p-1"
                  ariaHidden="true"
                />
              )}
            </DataTable.Cell>
            <DataTable.Cell style={{ width: "80px", textAlign: "center" }}>
              <Icon
                title={"Notification"}
                onClick={() =>
                  handleNotificationConfig(!showNotificationConfig, e.farm_uuid)
                }
                className="fa fa-bell cursor-pointer fa-lg p-1"
                ariaHidden="true"
              />
            </DataTable.Cell>
          </DataTable.Row>
        );
      })}
    </>
  );
};

export default FarmRow;
